import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { isPaidCheckoutOrder } from "../../../../utils/sellarHelpers";

export const useOrderContentState = (order: OrderGetResponseType) => {
  const [invoiceCreateDialogActive, setInvoiceCreateDialogActive] =
    useState<boolean>(false);
  const [
    sellarCreditInvoiceCreateDialogActive,
    setSellarCreditInvoiceCreateDialogActive,
  ] = useState<boolean>(false);
  const [xeroInvoiceDialogActive, setXeroInvoiceDialogActive] =
    useState<boolean>(false);
  const [issueRefundDialogActive, setIssueRefundDialogActive] =
    useState<boolean>(false);
  const [eventListDialogActive, setEventListDialogActive] =
    useState<boolean>(false);
  const [cancelOrderModalActive, setCancelOrderModalActive] =
    useState<boolean>(false);
  const [sellarCreditCancelWarningActive, setSellarCreditCancelWarningActive] =
    useState<boolean>(false);
  const [modifyOrderModalActive, setModifyOrderModalActive] =
    useState<boolean>(false);
  const [cancelRecreateDialogActive, setCancelRecreateDialogActive] =
    useState<boolean>(false);
  const [orderDeliveredDialogActive, setOrderDeliveredDialogActive] =
    useState(false);
  const [orderPaidDialogActive, setOrderPaidDialogActive] = useState(false);
  const [
    orderWithStripePaymentPaidDialogActive,
    setOrderWithStripePaymentPaidDialogActive,
  ] = useState(false);
  const [
    cardPaymentWithDepositManualPaymentDialogActive,
    setCardPaymentWithDepositManualPaymentDialogActive,
  ] = useState(false);
  const [orderCannotBeEditedActive, setOrderCannotBeEditedActive] =
    useState(false);
  const [createCreditNoteDialogActive, setCreateCreditNoteDialogActive] =
    useState<boolean>(false);
  const [
    createSellarImportCreditNoteDialogActive,
    setCreateSellarImportCreditNoteDialogActive,
  ] = useState<boolean>(false);
  const [
    adminChargeRemainingOrderBalanceActive,
    setAdminChargeRemainingOrderBalanceActive,
  ] = useState<boolean>(false);
  const [
    adminAddOrderToPalletDialogActive,
    setAdminAddOrderToPalletDialogActive,
  ] = useState<boolean>(false);
  const [
    adminRemoveOrderFromPalletDialogActive,
    setAdminRemoveOrderFromPalletDialogActive,
  ] = useState<boolean>(false);
  const [
    adminOrderAssignRouteAndCreateCtTaskActive,
    setAdminOrderAssignRouteAndCreateCtTaskActive,
  ] = useState<boolean>(false);

  const invoiceSent =
    !!order.invoiceFinalizedAt ||
    (!!order.invoiceIssuedAt && order.paymentType === "manual");
  const invoicePaid = !!order.paidAt;
  const cancelOrderText = isPaidCheckoutOrder({
    paidAt: order.paidAt,
    paymentType: order.paymentType,
  })
    ? "Cancel & Refund"
    : "Cancel order";

  const state = {
    invoiceCreateDialogActive,
    sellarCreditInvoiceCreateDialogActive,
    xeroInvoiceDialogActive,
    issueRefundDialogActive,
    eventListDialogActive,
    cancelOrderModalActive,
    sellarCreditCancelWarningActive,
    modifyOrderModalActive,
    cancelRecreateDialogActive,
    orderDeliveredDialogActive,
    orderPaidDialogActive,
    orderWithStripePaymentPaidDialogActive,
    cardPaymentWithDepositManualPaymentDialogActive,
    orderCannotBeEditedActive,
    createCreditNoteDialogActive,
    createSellarImportCreditNoteDialogActive,
    adminChargeRemainingOrderBalanceActive,
    adminAddOrderToPalletDialogActive,
    adminRemoveOrderFromPalletDialogActive,
    adminOrderAssignRouteAndCreateCtTaskActive,
    invoiceSent,
    invoicePaid,
    cancelOrderText,
  };

  const actions = {
    setInvoiceCreateDialogActive,
    setSellarCreditInvoiceCreateDialogActive,
    setXeroInvoiceDialogActive,
    setIssueRefundDialogActive,
    setEventListDialogActive,
    setCancelOrderModalActive,
    setSellarCreditCancelWarningActive,
    setModifyOrderModalActive,
    setCancelRecreateDialogActive,
    setOrderDeliveredDialogActive,
    setOrderPaidDialogActive,
    setOrderWithStripePaymentPaidDialogActive,
    setCardPaymentWithDepositManualPaymentDialogActive,
    setOrderCannotBeEditedActive,
    setCreateCreditNoteDialogActive,
    setCreateSellarImportCreditNoteDialogActive,
    setAdminChargeRemainingOrderBalanceActive,
    setAdminAddOrderToPalletDialogActive,
    setAdminRemoveOrderFromPalletDialogActive,
    setAdminOrderAssignRouteAndCreateCtTaskActive,
  };

  return { state, actions };
};

export type OrderContentState = ReturnType<
  typeof useOrderContentState
>["state"];
export type OrderContentActions = ReturnType<
  typeof useOrderContentState
>["actions"];
